export default facets =>
  facets.some(({ hasSelectedValues }) => hasSelectedValues);
